<template>
    <div class="ribbon-button-two-state" :class="{active: active, 'full-width': fullWidth}" @click="clicked">
        <div
            class="ribbon-button-text"
            :class="{condensed: condensed >= 2, slim: condensed === 1 || condensed === 3}"
        >{{ text }}</div>
        <div class="ribbon-button-image"></div>
    </div>
</template>

<script>
    export default {
        name: "RibbonButtonTwoState",
        props: {
            text:   String,
            click:  Function,
            active: Boolean,
            fullWidth: {
                type: Boolean,
                default: false
            },
            condensed: {
                type:    Number,
                default: 2
            }
        },
        methods: {
            clicked: function() {
                this.$emit('clicked');
            }
        }
    }
</script>

<style scoped>

    div.ribbon-button-two-state {
        width: 136px;
        height: 24px;
        display: inline-block;
        padding: 4px 4px;
        text-align: left;
    }
    div.ribbon-button-two-state.full-width {
        width: 100%;
        padding: 4px 0;
    }

    div.ribbon-button-two-state:hover {
        background-color: var(--sc-blue-dark-5-percent);
    }

    div.ribbon-button-two-state div.ribbon-button-image {
        height: 16px;
        width: 26px;
        display: inline-block;
        background-image: url("../../assets/icons/toolbar/toggle_off.svg");
        background-size: 26px;
        background-position: center;
    }
    div.ribbon-button-two-state.active div.ribbon-button-image {
        background-image: url("../../assets/icons/toolbar/toggle_on.svg");
    }

    div.ribbon-button-two-state div.ribbon-button-text {
        width: 100px;
        height: 16px;
        font-size: 10pt;
        display: inline-block;
        letter-spacing: 0.5px;
        vertical-align: top;
    }

    div.ribbon-button-two-state.full-width div.ribbon-button-text {
        text-align: left;
        width: auto;
        color: var(--toolbar-label);
        letter-spacing: normal;
    }

    div.condensed {
        font-family: D-DIN Condensed, monospace, sans-serif;
    }

    div.ribbon-button-two-state div.ribbon-button-text.slim {
        letter-spacing: unset;
    }

</style>